import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { RefreshCw, Sparkles } from "lucide-react";
import { toast } from "sonner";

const MorningBrief = () => {
  const [brief, setBrief] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    try {
      const b = await api.latestBrief();
      setBrief(b && b.outcomes ? b : null);
    } catch {
      setBrief(null);
    }
  };
  useEffect(() => { load(); }, []);

  const regenerate = async () => {
    setLoading(true);
    try {
      const b = await api.generateBrief();
      setBrief(b);
      toast("Brief regenerated", { description: b.source === "fallback" ? "Fallback logic used" : "Fresh from Claude." });
    } catch {
      toast("Brief generation failed");
    } finally {
      setLoading(false);
    }
  };

  const isStale = () => {
    if (!brief?.generated_at) return true;
    const g = new Date(brief.generated_at);
    return new Date() - g > 24 * 3600 * 1000;
  };

  if (!brief) {
    return (
      <section data-testid="morning-brief">
        <div className="op-panel op-panel--glow p-6 flex items-center justify-between flex-wrap gap-4">
          <div>
            <div className="op-microcopy text-[#00E5FF] mb-2">AI · MORNING BRIEF</div>
            <div className="text-white text-lg">No brief yet today. Generate now?</div>
          </div>
          <button
            onClick={regenerate}
            disabled={loading}
            data-testid="brief-generate"
            className="op-btn op-btn--primary inline-flex items-center gap-2"
          >
            <Sparkles size={12} />
            {loading ? "GENERATING…" : "GENERATE BRIEF"}
          </button>
        </div>
      </section>
    );
  }

  return (
    <section data-testid="morning-brief">
      <div className="op-panel op-panel--glow p-6 md:p-8 relative overflow-hidden">
        <div className="op-ghost-number text-[120px] absolute -right-2 -top-8">AM</div>
        <div className="flex items-start justify-between mb-6 relative z-10">
          <div>
            <div className="op-microcopy text-[#00E5FF] mb-2">AI · MORNING BRIEF · {brief.source?.toUpperCase()}</div>
            <div className="text-white text-2xl font-light tracking-tight">Today, in one glance.</div>
          </div>
          <button
            onClick={regenerate}
            disabled={loading}
            data-testid="brief-refresh"
            className={`op-tag inline-flex items-center gap-1.5 ${isStale() ? "text-[#F5A623]" : "hover:text-[#00E5FF]"}`}
            title="Regenerate"
          >
            <RefreshCw size={10} className={loading ? "animate-spin" : ""} />
            {isStale() ? "STALE · REGENERATE" : "REGENERATE"}
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr] gap-6 relative z-10">
          <div>
            <div className="op-tag mb-3">THREE OUTCOMES</div>
            <ol className="space-y-3" data-testid="brief-outcomes">
              {brief.outcomes.map((o, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="op-mono text-xs text-[#5E657D] mt-1">{String(i + 1).padStart(2, "0")}</span>
                  <span className="text-white text-base leading-snug">{o}</span>
                </li>
              ))}
            </ol>
          </div>
          <div>
            <div className="op-tag mb-3 text-[#00E5FF]">MONEY MOVE</div>
            <div className="text-white text-base leading-snug" data-testid="brief-money">
              {brief.money_move}
            </div>
          </div>
          <div>
            <div className="op-tag mb-3">WAITING ON</div>
            <div className="text-white text-base leading-snug" data-testid="brief-waiting">
              {brief.waiting_on_top}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MorningBrief;
